import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const OrdersPerDealershipChart = ({ data, selectedPeriod }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-modal">
          <p className="font-medium text-popover-foreground mb-2">{label}</p>
          <div className="space-y-1">
            <div className="flex items-center justify-between space-x-4">
              <span className="text-sm text-text-secondary">Anzahl Aufträge:</span>
              <span className="font-medium text-primary">{payload?.[0]?.value}</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-text-primary">Aufträge pro Autohaus</h2>
        <div className="text-sm text-text-secondary">
          Zeitraum: {selectedPeriod}
        </div>
      </div>
      
      <div className="h-96">
        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"   // 👈 important for horizontal bars
          margin={{ top: 20, right: 30, left: -20, bottom: 20 }} // give extra left margin for names
        >
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            type="number" 
            stroke="var(--color-text-secondary)" 
          />
          <YAxis 
            type="category" 
            dataKey="name" 
            stroke="var(--color-text-secondary)" 
            width={100}  // 👈 adjust width for long names
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar 
            dataKey="orders" 
            fill="var(--color-accent)" 
            radius={[0, 4, 4, 0]} // rounded right side
          />
        </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default OrdersPerDealershipChart;
